import UserProfileForm, { DEFAULT_OPTIONS } from 'CoreComponents/userProfileForm/';

document.querySelectorAll(DEFAULT_OPTIONS['selectors']['FORM']).forEach(form => {
  new UserProfileForm(form);
});
